exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mainmenubtn[data-v-588f4758]{color:#000;border:none;cursor:pointer}.mainmenubtn[data-v-588f4758]:hover{background-color:#f8f9fa}.dropdown[data-v-588f4758]{position:relative;display:inline-block}.dropdown-child[data-v-588f4758]{background-color:#f8f9fa;min-width:500px;position:absolute;left:20px;top:0;z-index:100;margin-top:20px;border:none;padding:8px;margin-top:8px}.dropdown-child a[data-v-588f4758]{color:#000;padding:8px;text-decoration:none;display:block;cursor:pointer}.dropdown:hover .dropdown-child[data-v-588f4758]{display:block}#id-do-elemento[data-v-588f4758]:hover{background-color:#e0e0e0;-webkit-transition:.5s;transition:.5s;opacity:.7}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-588f4758","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Expeditions_v2/Aggregates/ActionMenu/ActionMenuDropdown.vue
// module id = 2URw
// module chunks = 0